import React, { useEffect, useState } from 'react';
import { ArrowRight, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import { getConvertPreview, convertLegacy, money, fmtDate } from '../../utils/clientPricesApi';

export const LegacyConvertDialog = ({ row, onClose, onDone }) => {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { getConvertPreview(row.id).then(setP).catch((e) => toast.error(e.message)); }, [row.id]);
  const convert = async () => {
    setBusy(true);
    try { await convertLegacy(row.id); toast.success('Converted to Client Price — legacy row deactivated'); onDone(); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const Card = ({ title, tone, data, testId }) => (
    <div className={`rounded-lg border p-3 text-sm ${tone}`} data-testid={testId}>
      <div className="text-[11px] uppercase tracking-wider opacity-70">{title}</div>
      <div className="font-semibold mt-1">{data.scope_label || `${data.client_code || ''} · ${data.product_name}`}</div>
      <div className="mt-1">Price <strong>{money(data.price)}</strong></div>
      <div className="text-xs opacity-80">Effective {fmtDate(data.effective_from)}{data.effective_to ? ` → ${fmtDate(data.effective_to)}` : ' → open'}</div>
    </div>
  );
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="legacy-convert-dialog">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl p-6 space-y-4">
        <div><h3 className="font-semibold text-slate-900 text-lg">Convert to Client Price</h3><p className="text-xs text-slate-500">Creates an identical engine rule, then deactivates this legacy row. The legacy record itself is never edited or deleted. Reversible from Pricing Diagnostics.</p></div>
        {!p ? <div className="text-sm text-slate-500">Loading preview…</div> : (
          <>
            <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
              <Card title="Existing legacy price" tone="border-slate-200 bg-slate-50 text-slate-800" data={{ ...p.legacy, scope_label: `${p.new_rule.client_code} · ${p.legacy.product_name} · All States (legacy)` }} testId="convert-legacy-card" />
              <ArrowRight className="w-5 h-5 text-slate-400" />
              <Card title="New Client Price rule" tone="border-emerald-200 bg-emerald-50 text-emerald-900" data={p.new_rule} testId="convert-new-card" />
            </div>
            {p.blockers?.length > 0 && <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800 flex gap-2" data-testid="convert-blockers"><AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" /><div>{p.blockers.map((b) => <div key={b}>{b}</div>)}</div></div>}
            <p className="text-xs text-slate-600" data-testid="convert-effect">{p.effect}</p>
          </>
        )}
        <div className="flex justify-end gap-2"><button onClick={onClose} className="px-4 py-2 rounded-md border text-sm" data-testid="convert-cancel-btn">Cancel</button><button onClick={convert} disabled={busy || !p?.can_convert} className="px-4 py-2 rounded-md bg-emerald-600 text-white text-sm font-medium disabled:opacity-50" data-testid="convert-confirm-btn">{busy ? 'Converting…' : 'Convert & Deactivate Legacy Row'}</button></div>
      </div>
    </div>
  );
};
